import { render, staticRenderFns } from "./SBoxStemdoerCompsAndCerts.vue?vue&type=template&id=4c2060a6&scoped=true"
import script from "./sBoxStemdoerCompsAndCerts.ts?vue&type=script&lang=ts&external"
export * from "./sBoxStemdoerCompsAndCerts.ts?vue&type=script&lang=ts&external"
import style0 from "./SBoxStemdoerCompsAndCerts.vue?vue&type=style&index=0&id=4c2060a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2060a6",
  null
  
)

export default component.exports